import { ReactNode } from 'react';

export type StateType = 'info' | 'error' | 'fatal' | 'success';
export interface IFeedbackDescriptionProps {
  className?: string;
  text: string;
  status: StateType;
  icon?: ReactNode;
  link?: ReactNode;
  hasBg: boolean;
  hasStatusIcon: boolean;
  hasLinkIcon: boolean;
}

export interface IIconProps {
  hasStatusIcon?: boolean;
  hasLinkIcon?: boolean;
  status: StateType;
}

type Union<T> = T[keyof T];
export const statusIconObj = {
  error: 'state-error-solid',
  fatal: 'state-fatal',
  success: 'check-solid',
  info: 'state-info'
} as const;

export type StatusIconType = Union<typeof statusIconObj>;
